<template>
  <div
    v-if="item"
    class="group relative col-span-1 row-span-1 bg-gradient-03 max-xs:aspect-square"
    :class="{
      '2xl:odd:col-span-7 2xl:even:col-span-5 lg:col-span-6 lg:first:col-span-12 lg:last:order-1 lg:even:order-2 xl:first:col-span-6 xl:last:order-2 xl:even:row-span-2': mosaicMd,
      '2xl:col-span-7 2xl:odd:row-span-1 2xl:even:row-span-1 2xl:[&:nth-child(3n+2)]:col-span-5 2xl:[&:nth-child(3n+3)]:col-span-5 lg:col-span-6 lg:odd:row-span-3 lg:even:row-span-2': mosaicLg,
    }"
    role="button"
    tabindex="0"
    @mouseenter="playVideo(index)"
    @focusin="playVideo(index)"
    @mouseleave="pauseVideo(index)"
    @focusout="playVideo(index)"
  >
    <BackgroundMedia
      :ref="(el) => {
        items[index] = el as BackgroundMediaInstance
      }"
      :data="item"
      :autoplay="false"
    />
    <AppImage
      v-if="item.media_type?.value === 'image' && item.hover_image && item.hover_image.is_image"
      :src="item.hover_image"
      class="
        absolute inset-0 size-full bg-gradient-02 object-cover opacity-0 transition-opacity duration-300
        ease-in
        group-hover-focus:opacity-100 group-hover-focus:delay-75 group-hover-focus:duration-500
        group-hover-focus:ease-in-out
      "
    />
    <NuxtLink
      v-if="item.link && item.link_text"
      :to="item.link"
      class="absolute inset-0 z-10 w-full !max-w-full font-semibold text-white typo-h4"
    >
      <div
        class="
          absolute inset-x-6 bottom-9 flex items-center justify-between rounded-100 bg-secondary-900/15 px-4
          py-2.5 backdrop-blur-sm
          after:absolute after:inset-0 after:z-[-1] after:bg-black/15 after:mix-blend-darken
          after:backdrop-blur-sm
          before:absolute before:inset-0 before:z-[1] before:bg-white/35 before:mix-blend-multiply
        "
      >
        {{ item.link_text }}
        <div class="flex size-10 shrink-0 items-center justify-center rounded-100 bg-primary-900">
          <IconArrowUpRight class="size-[1.875rem]" />
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import type { MainComponentsTeaserFlexibleFragment } from '#gql'

type TeaserItem = NonNullable<MainComponentsTeaserFlexibleFragment['teaser_items']>[number]

type BackgroundMediaInstance = ComponentPublicInstance<
  {
    playVideo: () => void
    pauseVideo: () => void
  } // The exposed methods
>

defineProps<{
  item: Enforce<TeaserItem>
  index: number
  mosaicMd: boolean
  mosaicLg: boolean
}>()

const items = ref<(BackgroundMediaInstance | null)[]>([])

const playVideo = (index: number) => {
  const item = items.value[index]
  if (item) {
    item.playVideo()
  }
}

const pauseVideo = (index: number) => {
  const item = items.value[index]
  if (item && item.pauseVideo) {
    setTimeout(() => {
      item.pauseVideo()
    }, 300)
  }
}
</script>
